import axios from 'axios';
import history from "../history";
import queryString from 'query-string';

const parsed1 = queryString.parse(history.location.search);

axios.defaults.headers.common["Token"] = parsed1.sessionid;
const request = axios.create({
    headers: {
        "Content-Type": "application/json"
    }
});

const file_request = axios.create({
    headers : {
        'Content-Type': 'multipart/form-data'
    }
});


export function getRequest({url,data, params}) {
    return request.get(url, data,{params: params});
}

export function postRequest({url, data, params,sessionid}) {
    return request.post(url, data, {params:params});
}

export function postFileRequest({url, data}) {
    return file_request.post(url, data);
}

